/* global JSX */
// @packages
import React from 'react';
import {
  Route, Routes
} from 'react-router-native';

// @scripts
import Dashboard from '../../screens/dashboard';
import Login from '../../screens/login';
import ChangePasswordFirstTime from '../../screens/change-password-first-time';
import MainLayout from '../../components/layouts/main-layout';
import ProtectedRoute from './ProtectedRoute';
import SiteScheduleDetail from '../../screens/site-schedule-detail';
import ForgotPassword from '../../screens/forgot-password';
import ForgotPasswordSendRecovery from '../../screens/forgot-password-send-recovery';
import { routes, routesOutLogged } from './config';

const RouterComponents: Record<string, JSX.Element> = {
  Dashboard: <Dashboard />,
  SiteScheduleDetail: <SiteScheduleDetail />
};

const RouterMapper = () => (
  <Routes>
    <Route index element={<Login />} />
    <Route element={<MainLayout />}>
      <Route
        path={routesOutLogged.forgotPassword.path}
        element={<ForgotPassword />}
      />
      <Route
        path={routesOutLogged.forgotPasswordSendRecovery.path}
        element={<ForgotPasswordSendRecovery />}
      />
      <Route path={routesOutLogged.changePassword.path} element={<ChangePasswordFirstTime />} />
      <Route element={<ProtectedRoute isAllowed redirectPath={routesOutLogged.login.path} />}>
        {Object.values(routes).map((route) => (
          <Route key={route.path} path={route.path} element={RouterComponents[route.element]}>
            {!!route.routes
              && route.routes.map((subRoute, subIndex) => (
                <Route
                  key={subRoute.path}
                  index={!subIndex}
                  path={subRoute.path}
                  element={RouterComponents[subRoute.element]}
                />
              ))}
          </Route>
        ))}
      </Route>
    </Route>
  </Routes>
);

export default RouterMapper;
